import { createSelector } from 'reselect';

import { version, wrapperApiVersion } from '../external_data';

import { getClientCode, getSessionKey, getUserLoggedIn } from './Login';
import {
  getCurrentPosLanguage,
  getPosDefaultLanguage,
} from './configs/settings';
import { getSelectedPosID } from './PointsOfSale';
import { getSelectedWarehouseID } from './warehouses';

export const getWrapperInfo = (): Partial<WrapperInfo> => {
  const data = window.wrapperInfo;
  return {
    ...(data ?? {}),
    printLayouts: data?.printLayouts ? new Set(data?.printLayouts) : undefined,
  };
};

export const getWrapperData = createSelector(
  getClientCode,
  getSessionKey,
  getPosDefaultLanguage,
  getCurrentPosLanguage,
  getSelectedPosID,
  getSelectedWarehouseID,
  getUserLoggedIn,
  (
    clientCode,
    sessionKey,
    posDefaultLang,
    posLang,
    posID,
    warehouseID,
    user,
  ) => ({
    clientCode,
    sessionKey,
    receiptLang: posDefaultLang?.legacyIdentifier,
    posLang,
    posID,
    warehouseID,
    userID: user?.employeeID,
    apiVersion: wrapperApiVersion,
    posVersion: version,
    softwareName: 'Erply Brazil POS',
    softwareVersion: version,
  }),
);
